import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path
      key='0'
      d='M10.9,16.6l-3.6-3.7L6.2,14l1.9,1.9l-0.8-0.2C4.8,15.2,3,13.1,3,10.6c0-2.9,2.4-5.2,5.2-5.2H11V3.8H8.2
	c-3.7,0-6.8,3-6.8,6.8c0,3.4,2.6,6.3,5.9,6.7l0.6,0.1l-1.9,1.8l1.1,1.1L10.9,16.6z'
    />,
    <path key='1' d='M22.2,10.6v-7h-9v7H22.2z M20.9,9.3h-6.3V5h6.3V9.3z' />,
    <path
      key='2'
      d='M17.7,13.4c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1S16,13.4,17.7,13.4 M17.8,12
        c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S20.2,12,17.8,12L17.8,12z'
    />,
  ],
  'ChangeGeofenceShape'
);

const ChangeGeofenceShapeIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(ChangeGeofenceShapeIcon);
